import { IAction, IAlertData, IDataContext, IFilterData, ISelectedNode } from "../types";

export const MULTI_ACTION = "MULTI_ACTION";
export const TOGGLE_RIGHT_PANEL = "TOGGLE_RIGHT_PANEL";
export const TOGGLE_LEFT_PANEL = "TOGGLE_LEFT_PANEL";
export const TOGGLE_BOTTOM_PANEL = "TOGGLE_BOTTOM_PANEL";

export const SET_DATA_CONTEXT  = "SET_DATA_CONTEXT";

export const TOGGLE_DARK_MODE = "TOGGLE_DARK_MODE";
export const SET_LANGUAGE = "SET_LANGUAGE";

export const ADD_ALERT = "ADD_ALERT";
export const DEL_ALERT = "DEL_ALERT";

export const SELECTED_NODE = "SELECTED_NODE";

export const UPDATE_FILTER_DATA = "UPDATE_FILTER_DATA";

export const SHOW_MESSAGE = "SHOW_MESSAGE";


export const executeMultiActions = (actions: IAction[]): IAction => ({
  type: MULTI_ACTION,
  payload: actions
});

export const toggleRightPanel = (): IAction => ({
  type: TOGGLE_RIGHT_PANEL,
  payload: null
});

export const toggleLeftPanel = (): IAction => ({
  type: TOGGLE_LEFT_PANEL,
  payload: null
});

export const toggleBottomMenu = (): IAction => ({
  type: TOGGLE_BOTTOM_PANEL,
  payload: null
});

export const setDataContext = (dataContext: IDataContext): IAction => ({
  type: SET_DATA_CONTEXT,
  payload: dataContext
});

export const setDarkMode = (darkMode: boolean): IAction => ({
  type: TOGGLE_DARK_MODE,
  payload: darkMode
});

export const setLanguage = (language: "es-mx" | "pt-br" | "en-us"): IAction => ({
  type: SET_LANGUAGE,
  payload: language
});

export const addAlert = (alertData: IAlertData): IAction => ({
  type: ADD_ALERT,
  payload: alertData
});

export const delAlert = (hash: string): IAction => ({
  type: DEL_ALERT,
  payload: hash
});

export const selectedNode = (node: ISelectedNode): IAction => ({
  type: SELECTED_NODE,
  payload: node
});

export const updateFilter = (filter: IFilterData): IAction => ({
  type: UPDATE_FILTER_DATA,
  payload: filter
});

// export const showMessage = (messageContext: IMessageContext): IAction => ({
//   type: SHOW_MESSAGE,
//   payload: messageContext
// });

